/**
 * Shared trigger for the global "Upload Signal" modal (owned by Navigation).
 *
 * Any component can ask for the upload modal to open without prop-drilling or a
 * dedicated context: it dispatches a window CustomEvent that Navigation listens
 * for. Navigation is always mounted in the authenticated layout, so this works
 * from every page (Dashboard, Knowledge Graph, Interventions, …).
 */
export const OPEN_UPLOAD_EVENT = 'retainiq:open-upload';

export function openUploadModal(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_UPLOAD_EVENT));
}
